import {useUpdateSetting} from '../../core/use-update-setting';
import {CTABannerDemio} from '../../master-dashboard/dash-grid/cards/demio/cta-banner-demio';
import {getImageInfoFromCTAKey} from '../../master-dashboard/dash-grid/cards/helpers';

import {useGetIntroWebcastBanner} from './graphql/hooks/use-get-intro-webcast-banner';

type Props = {
    canDismiss: boolean;
};

export function IntroWebcastBanner(props: Props) {
    const {introWebcastBanner: banner, refetch} = useGetIntroWebcastBanner();
    const updateSetting = useUpdateSetting();

    const handleRemoveBanner = (settingName: string, shouldRefetch: boolean) => {
        updateSetting({
            settingName,
            value: '1',
        }).then(() => {
            if (shouldRefetch) {
                refetch();
            }
        });
    };

    if (!banner || !banner.demioEvent) return null;

    return (
        <CTABannerDemio
            key={banner.demioEvent.id}
            title={banner.demioEvent.name}
            subtitle={banner.subtitle}
            image={getImageInfoFromCTAKey(banner.key)}
            demioEvent={banner.demioEvent}
            upcomingEvents={banner.upcomingEvents}
            onDismiss={
                props.canDismiss
                    ? () => {
                          handleRemoveBanner(banner.dismissSettingName, true);
                      }
                    : undefined
            }
            includeImage={true}
            includeBody={true}
            includeRemoveButton={true}
            fullSizeImage={true}
            useDoyleTitle={true}
        />
    );
}
